/* URSA variant hover preview: shows the product/variant image when hovering option buttons and swatches.
   6 Oct 2026 (late): hover-intent delay, softer eased fade and rise, and once open it glides and cross-fades
   between neighbouring options instead of popping. Previous: assets/ursa-variant-preview.js.before-timing-2026-10-06.txt (git tag pre-cleanup-2026-10-19)
   Motion pack: colour swatches hand over to ursa-swatch-gallery.js (main photo changes) when the photo is on screen. */
(function () {
  if (window.__ursaVariantPreview) return;
  window.__ursaVariantPreview = true;
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DELAY = 260;  /* ms the pointer must rest before the first preview opens */
  var WARM = 400;   /* ms after closing during which the next one opens instantly */
  var GRACE = 140;  /* ms grace when leaving, so crossing gaps between swatches does not flicker */
  var EASE = 'cubic-bezier(.22,.61,.36,1)';
  var SEL = 'variant-picker .variant-option__button-label';

  var css = '.ursa-vp{position:fixed;z-index:99999;pointer-events:none;background:#fff;border:1px solid rgba(27,39,83,.10);border-radius:14px;box-shadow:0 2px 6px rgba(27,39,83,.06),0 18px 44px rgba(27,39,83,.16);padding:7px;width:200px;opacity:0;transform:translateY(8px) scale(.965);filter:blur(2px);transform-origin:50% 100%;transition:opacity .18s ease,transform .22s ease,filter .18s ease;will-change:opacity,transform}' +
    '.ursa-vp.is-below{transform-origin:50% 0;transform:translateY(-8px) scale(.965)}' +
    '.ursa-vp.is-on{opacity:1;transform:none;filter:none;transition:opacity .38s ' + EASE + ',transform .46s ' + EASE + ',filter .38s ' + EASE + '}' +
    '.ursa-vp.is-on.is-glide{transition:opacity .38s ' + EASE + ',transform .46s ' + EASE + ',filter .38s ' + EASE + ',left .32s ' + EASE + ',top .32s ' + EASE + '}' +
    '.ursa-vp img{display:block;width:186px;height:186px;object-fit:contain;border-radius:9px;background:#f6f7fb;transition:opacity .22s ease}' +
    '.ursa-vp img.is-swap{opacity:0}' +
    '.ursa-vp span{display:block;text-align:center;font-size:12px;letter-spacing:.02em;line-height:1.3;padding:7px 4px 2px;color:#1b2753;font-weight:600}' +
    (reduce ? '.ursa-vp,.ursa-vp.is-below,.ursa-vp.is-on,.ursa-vp.is-on.is-glide,.ursa-vp img{transition:opacity .15s linear!important;transform:none!important;filter:none!important}' : '');
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var tip = document.createElement('div');
  tip.className = 'ursa-vp';
  tip.setAttribute('aria-hidden', 'true');
  tip.innerHTML = '<img alt=""><span></span>';
  document.body.appendChild(tip);
  var img = tip.querySelector('img'), cap = tip.querySelector('span');

  var cache = {}, current = null, showT = 0, hideT = 0, hiddenAt = 0, token = 0;

  function getJSON(url) {
    var u = url.split('?')[0].split('#')[0].replace(/\/$/, '') + '.js';
    if (!cache[u]) cache[u] = fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return cache[u];
  }
  function sized(src) {
    if (!src) return null;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=372';
  }
  function isSizeOption(el) {
    var input = el.querySelector('input');
    return !!input && /^(pouch )?size-/i.test(input.name || '');
  }
  function resolve(el) {
    var picker = el.closest('variant-picker');
    if (!picker) return Promise.resolve(null);
    var text = (el.querySelector('input') ? el.querySelector('input').value : el.textContent).trim();
    if (el.tagName === 'A') {
      var url = el.getAttribute('href') || picker.getAttribute('data-product-url');
      return getJSON(url).then(function (p) {
        if (!p) return null;
        var pref = p.variants.filter(function (x) {
          return x.featured_image && x.options.some(function (o) { return /^(beige|caramel)$/i.test(o); });
        })[0];
        var src = pref ? pref.featured_image.src : p.featured_image;
        return src ? { src: src, label: text } : null;
      });
    }
    var input = el.querySelector('input');
    if (!input) return Promise.resolve(null);
    var pos = parseInt((input.getAttribute('data-input-id') || '').split('-')[0], 10);
    if (!pos) return Promise.resolve(null);
    return getJSON(picker.getAttribute('data-product-url')).then(function (p) {
      if (!p) return null;
      var want = [];
      picker.querySelectorAll('fieldset.variant-option input[type=radio]:checked').forEach(function (i) {
        var n = parseInt((i.getAttribute('data-input-id') || '').split('-')[0], 10);
        if (n) want[n - 1] = i.value;
      });
      want[pos - 1] = input.value;
      var v = p.variants.filter(function (x) {
        return want.every(function (w, k) { return w == null || x.options[k] === w; });
      })[0] || p.variants.filter(function (x) { return x.options[pos - 1] === input.value; })[0];
      var s = v && v.featured_image && v.featured_image.src;
      return s ? { src: s, label: text } : null;
    });
  }
  function place(el) {
    var r = el.getBoundingClientRect(), w = tip.offsetWidth, h = tip.offsetHeight;
    var x = Math.max(8, Math.min(window.innerWidth - w - 8, r.left + r.width / 2 - w / 2));
    var y = r.top - h - 12, below = false;
    if (y < 8) { y = r.bottom + 12; below = true; }
    tip.classList.toggle('is-below', below);
    tip.style.left = x + 'px';
    tip.style.top = y + 'px';
  }
  function isOn() { return tip.classList.contains('is-on'); }
  function warm() { return isOn() || Date.now() - hiddenAt < WARM; }
  function hideNow() {
    clearTimeout(showT); clearTimeout(hideT); token++;
    if (isOn()) hiddenAt = Date.now();
    current = null;
    tip.classList.remove('is-on', 'is-glide');
  }
  function leave() {
    clearTimeout(showT); clearTimeout(hideT);
    current = null; token++;
    hideT = setTimeout(hideNow, GRACE);
  }
  function display(el, d) {
    var s = sized(d.src), my = ++token, pre = new Image();
    pre.onload = function () {
      if (my !== token || current !== el) return;
      if (isOn()) {
        /* already open: glide to the new option and cross-fade the picture */
        tip.classList.add('is-glide');
        place(el);
        if (img.getAttribute('src') !== s) {
          img.classList.add('is-swap');
          setTimeout(function () {
            if (my !== token) return;
            img.src = s; cap.textContent = d.label;
            img.classList.remove('is-swap');
          }, reduce ? 0 : 120);
        } else {
          cap.textContent = d.label;
        }
      } else {
        tip.classList.remove('is-glide');
        img.classList.remove('is-swap');
        img.src = s; cap.textContent = d.label;
        place(el);
        void tip.offsetWidth;
        tip.classList.add('is-on');
      }
    };
    pre.src = s;
  }

  document.addEventListener('mouseover', function (e) {
    var el = e.target.closest && e.target.closest(SEL);
    if (!el) return;
    if (el === current) { clearTimeout(hideT); return; }
    if (isSizeOption(el)) { if (current || isOn()) leave(); return; }
    /* colour swatches change the main photo instead when that is on screen (ursa-swatch-gallery.js) */
    if (window.__ursaSG && window.__ursaSG.owns(el)) { if (current || isOn()) leave(); return; }
    clearTimeout(hideT); clearTimeout(showT);
    current = el;
    var data = resolve(el); /* start fetching during the delay so it is ready when it opens */
    showT = setTimeout(function () {
      data.then(function (d) {
        if (current !== el) return;
        if (!d) { hideNow(); return; }
        display(el, d);
      });
    }, warm() ? 0 : DELAY);
  });
  document.addEventListener('mouseout', function (e) {
    var el = e.target.closest && e.target.closest(SEL);
    if (el && el === current && !el.contains(e.relatedTarget)) leave();
  });
  document.addEventListener('click', function () { hideNow(); hiddenAt = 0; }, true);
  window.addEventListener('scroll', hideNow, { passive: true });
})();
